import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library/build/components/atoms/Button/Button.component';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import api from 'api';
import confirm from 'modules/confirm';

import './UserTableCells.styles.scss';
import './UserTableCells.styles.responsive.scss';

type UserTableCellsProps = {
  className?: string;
  val: any;
  config?: Record<string, any>;
};

export const DeleteUserCell: React.FC<UserTableCellsProps> = ({
  className,
  config,
}) => {
  const { popError, popSuccess } = useContext(PopNotificationsContext);
  const { t } = useTranslation();
  const {
    instance: { id: userId },
    updateTableData,
    setIsTableLoading,
  } = config;

  const deleteManager = useCallback(async () => {
    try {
      if (
        await confirm(
          {
            title: t('deleteUser'),
            content: t('areYouSureDelUser'),
            type: 'delete',
          },
          true,
        )
      ) {
        setIsTableLoading?.();
        await api.user.managers.deleteManager(userId);
        updateTableData((old: any[]) => old.filter((u) => u.id !== userId));
        popSuccess(t('userSuccessfullyDeleted'));
      }
    } catch (e) {
      popError(e);
    }
  }, [popError, popSuccess, setIsTableLoading, t, updateTableData, userId]);

  const classes = classNames('delete-user-table-cell', className);

  return (
    <div className={classes}>
      <Button onClick={deleteManager}>{t('delete')}</Button>
    </div>
  );
};
